module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-2.ce8d1da4.svg";